// import { MbeEdit } from '@/components/icons';
import type { IAuthSignupFields } from '@/types';
import { Flex, Heading, Text } from '@chakra-ui/react';
// import { useLocation } from 'react-router-dom';

interface IUserInfoBoxProps {
  user?: IAuthSignupFields | undefined;
}

export const UserInfoBox = (props: IUserInfoBoxProps): JSX.Element => {
  // const { pathname } = useLocation();
  const { user } = props;
  return (
    <Flex justifyContent="space-between">
      <Flex direction="column">
        <Heading fontSize="h2.md" fontWeight="normal" lineHeight="taller">
          {user?.firstName} {user?.lastName}
        </Heading>
        <Text>{user?.streetAddress}</Text>
        <Text>
          {user?.zipCode} {user?.city} {user?.province}
        </Text>
      </Flex>
      {/* {pathname !== '/user/settings' && (
        <Button alignItems="flex-start" m={0} p={0}>
          <Icon as={MbeEdit} h={14} w={14} />
        </Button>
      )} */}
    </Flex>
  );
};
